export default "__VITE_ASSET__CWG45a56__"